import React, { useEffect, useState } from 'react';
import { Accordion, Button, Col, Container, Form, Row, Table } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

import StepHeader from "../../../components/v2/StepHeader"
import DepartmentHeader from "../../../components/v2/DepartmentHeader";
import DataAnalysisDialog from '../../../components/v2/DataAnalysisDialog';

import FORM_QUESTIONS from '../../../step4_questions.json';

const FAST_URL = process.env.REACT_APP_DS_API_URL

function EditButton(props) {
    return (
        <>
        {props.completed
            ?
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
                <FontAwesomeIcon icon={faCheck} inverse 
                    id="icon"
                    onClick={props.onClick}
                    />
            </Button>
            :
            <Button
                onClick={props.onClick}
                variant="success"
                className="w-100"
                size="md"
                id={'program-' + props.programId + '_slo-' + props.sloId}
                disabled={props.disabled}
                >
                <span className="px-2" id="edit">Edit</span>
            </Button>
        }
        </>
        
    )
}

function CompletedCheckBox(props) {
    return (
        <Form.Check
            type="checkbox"
            onChange={props.onChange}
            id={'program-' + props.programId + '_step-' + props.step}
            name={'program-' + props.programId + '_step-' + props.step}
            aria-label={props.ariaLabel}
            label={props.label}
            value={props.completed}
            defaultChecked={props.defaultChecked}
            disabled={props.disabled}
            />
    )
}

const EMPTY_DATA_ANALYSIS = {
    summaryOfResults: "",
    reflectionOnHypothesis: "",
    interpretationOfResults: "",
    followUpQuestions: "",
    actionsForImprovement: "",
}

export default function AssessmentStep4(props) {
    const [programId, setProgramId] = useState(0);

    // Used for Data Analysis Dialog
    const [selectedProgram, setSelectedProgram] = useState()
    const [selectedLearningOutcome, setSelectedLearningOutcome] = useState()
    const [stepData, setStepData] = useState(EMPTY_DATA_ANALYSIS)
    const [stepDataStore, setStepDataStore] = useState({})
    const [showModal, setShowModal] = useState(false);

    const [programDataCache, setProgramDataCache] = useState({})
    let prefix = "program-"

    useEffect(() => {
        if (programId && !(programId in programDataCache)) {
            let url = FAST_URL + "/program-data?programId=" + programId + "&reviewYear=2019-2020&reviewYear=2020-2021&reviewYear=2021-2022"
            fetch(url)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let tempCache = {...programDataCache}
                tempCache[programId] = data
                setProgramDataCache(tempCache)
            })
            .catch(err => {
                console.log(err)
            })
        }
    }, [programId])

    useEffect(() => {
        if (selectedLearningOutcome && (selectedLearningOutcome.sloId in stepDataStore)) {
            setStepData({...stepDataStore[selectedLearningOutcome.sloId]})
        } else {
            setStepData({...EMPTY_DATA_ANALYSIS})
        }
    }, [stepDataStore])

    useEffect(() => {
        if (selectedProgram && (selectedProgram.programId in props.step4DataStore)) {
            setStepDataStore({...props.step4DataStore[selectedProgram.programId]})
        } else {
            setStepDataStore({})
            setStepData({...EMPTY_DATA_ANALYSIS})
        }
    }, [selectedProgram])

    const handleOpenEditDialog = (event) => {
        let id = event.target.id
        let tokens = event.target.id.split('_')
        if (id === 'edit' || id === 'icon') {
            tokens = event.target.parentElement.id.split('_')
        }
        let programId = tokens[0].split('-')[1]
        let sloId = tokens[1].split('-')[1]
        let program = props.department.submittedPrograms.find(p => p.programId == programId)
        
        setSelectedProgram(program)

        // Update which learning outcome the edit dialog was opened for.
        let slo = props.learningOutcomes[programId].find(lo => lo.sloId == sloId)
        
        setSelectedLearningOutcome({...slo})
        setStepData({...stepDataStore[sloId]})

        setShowModal(true)
    }

    const handleLearningOutcomeChanged = (event) => {
        let tmpLearningOutcome = selectedLearningOutcome ? selectedLearningOutcome : props.selectedLearningOutcome
        let previousSloId = tmpLearningOutcome.sloId
        let nextSloId = event.target.value
        let tmpSelectedProgram = selectedProgram ? selectedProgram : props.selectedProgram

        let slo = props.learningOutcomes[tmpSelectedProgram.programId].find(lo => lo.sloId == nextSloId)
        setSelectedLearningOutcome(slo)

        // Save the previous step data
        let dirtyStepDataStore = {...stepDataStore}
        dirtyStepDataStore[previousSloId] = {...stepData}
        setStepDataStore({...dirtyStepDataStore})

        // Show the next step data
        if (nextSloId in stepDataStore) {
            setStepData({...stepDataStore[nextSloId]})
        } else {
            // No step data exists using nextSloId, use blank fields
            setStepData({...EMPTY_DATA_ANALYSIS})
        }
    }

    const handleCancelDialog = () => setShowModal(false)
    const handleCloseDialog = () => {
        let sloId = selectedLearningOutcome.sloId
        let dirtyStepDataStore = {...stepDataStore}
        dirtyStepDataStore[sloId] = {...stepData}
        setStepDataStore({...dirtyStepDataStore})

        let data = {
            department: props.department,
            program: selectedProgram,
            learningOutcome: props.selectedLearningOutcome,
            stepDataStore: {...dirtyStepDataStore},
        }

        // Notify parent that we are saving step 4 data
        props.handleStep4DialogSave(data)

        // Hide modal
        setShowModal(false)
    }

    const isStep2DataAvailable = (programId, sloId) => {
        if (props.step2DataStore && (programId in props.step2DataStore)) {
            let step2Data = props.step2DataStore[programId]
            if (sloId in step2Data) {
                return false
            }
        }
        return true
    }

    const isLearningOutcomeDataComplete = (programId, sloId) => {
        let result = true
        if (programId in props.step4DataStore &&
            sloId in props.step4DataStore[programId]) {
            
            let textSummaryOfResults = props.step4DataStore[programId][sloId].summaryOfResults
            let summaryOfResultsRequired = FORM_QUESTIONS["summaryOfResults"].required
            if (summaryOfResultsRequired &&
                (!textSummaryOfResults || textSummaryOfResults.trim().length == 0)) {
                result = false
            }

            let textReflectionOnHypothesis = props.step4DataStore[programId][sloId].reflectionOnHypothesis
            let reflectionOnHypothesisRequired = FORM_QUESTIONS["reflectionOnHypothesis"].required
            if (reflectionOnHypothesisRequired &&
                (!textReflectionOnHypothesis || textReflectionOnHypothesis.trim().length == 0)) {
                result = false
            }

            let textInterpretationOfResults = props.step4DataStore[programId][sloId].interpretationOfResults
            let interpretationOfResultsRequired = FORM_QUESTIONS["interpretationOfResults"].required
            if (interpretationOfResultsRequired &&
                (!textInterpretationOfResults || textInterpretationOfResults.trim().length == 0)) {
                result = false
            }

            let textFollowUpQuestions = props.step4DataStore[programId][sloId].followUpQuestions
            let followUpQuestionsRequired = FORM_QUESTIONS["followUpQuestions"].required
            if (followUpQuestionsRequired &&
                (!textFollowUpQuestions || textFollowUpQuestions.trim().length == 0)) {
                result = false
            }

            let textActionsForImprovement = props.step4DataStore[programId][sloId].actionsForImprovement
            let actionsForImprovementRequired = FORM_QUESTIONS["actionsForImprovement"].required
            if (actionsForImprovementRequired &&
                (!textActionsForImprovement || textActionsForImprovement.trim().length == 0)) {
                result = false
            }
        }
        else {
            result = false
        }
        return result
    }

    const isStepComplete = (programId) => {

        // Prevent edit of step if next step is complete
        if (props.step5CompletionData[programId] &&
            props.step5CompletionData[programId].completed) {
            return false
        }

        // Step cannot be completed if previous steps were not.
        if (!props.step1CompletionData[programId] ||
            !props.step1CompletionData[programId].completed) {
            return false
        }
        if (!props.step2CompletionData[programId] ||
            !props.step2CompletionData[programId].completed) {
            return false
        }
        if (!props.step3CompletionData[programId] ||
            !props.step3CompletionData[programId].completed) {
            return false
        }

        let result = true
        availableLearningOutcomes[programId].map((slo) => {
            if (programId in props.step4DataStore &&
                slo.sloId in props.step4DataStore[programId]) {
                
                let textSummaryOfResults = props.step4DataStore[programId][slo.sloId].summaryOfResults
                let summaryOfResultsRequired = FORM_QUESTIONS["summaryOfResults"].required
                if ( summaryOfResultsRequired &&
                    (!textSummaryOfResults || textSummaryOfResults.trim().length == 0)) {
                    result = false
                }

                let textReflectionOnHypothesis = props.step4DataStore[programId][slo.sloId].reflectionOnHypothesis
                let reflectionOnHypothesisRequired = FORM_QUESTIONS["reflectionOnHypothesis"].required
                if ( reflectionOnHypothesisRequired &&
                    (!textReflectionOnHypothesis || textReflectionOnHypothesis.trim().length == 0)) {
                    result = false
                }

                let textInterpretationOfResults = props.step4DataStore[programId][slo.sloId].interpretationOfResults
                let interpretationOfResultsRequired = FORM_QUESTIONS["interpretationOfResults"].required
                if ( interpretationOfResultsRequired &&
                    (!textInterpretationOfResults || textInterpretationOfResults.trim().length == 0)) {
                    result = false
                }

                let textFollowUpQuestions = props.step4DataStore[programId][slo.sloId].followUpQuestions
                let followUpQuestionsRequired = FORM_QUESTIONS["followUpQuestions"].required
                if ( followUpQuestionsRequired &&
                    (!textFollowUpQuestions || textFollowUpQuestions.trim().length == 0)) {
                    result = false
                }

                let textActionsForImprovement = props.step4DataStore[programId][slo.sloId].actionsForImprovement
                let actionsForImprovementRequired = FORM_QUESTIONS["actionsForImprovement"].required
                if ( actionsForImprovementRequired &&
                    (!textActionsForImprovement || textActionsForImprovement.trim().length == 0)) {
                    result = false
                }
            }
            else {
                result = false
            }
        })
        
        return result
    }

    React.useEffect(() => {
        window.scrollTo(0,0)
    }, [])

    let allPrograms = props.department.submittedPrograms
    let filteredPrograms = []

    if (filteredPrograms.length == 0) {
        filteredPrograms = allPrograms.filter(function(obj) {
            return (props.activePrograms[obj.programId] == 'yes')
        })
    }
    
    let themeName = props.theme.name
    let availableLearningOutcomes = {}

    props.department.submittedPrograms.map(program => {
        let programMappedSlos = props.mappedSlos[program.programId]
        if (!(program.programId in availableLearningOutcomes)) {
            availableLearningOutcomes[program.programId] = []
        }

        if (program.programId in props.learningOutcomes) {
            props.learningOutcomes[program.programId].map(slo => {
                if (slo.sloId in programMappedSlos) {
                    let mappedSlo = programMappedSlos[slo.sloId]
                    if (mappedSlo.firstTheme === themeName && mappedSlo.firstThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.secondTheme === themeName && mappedSlo.secondThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    } else if (mappedSlo.thirdTheme === themeName && mappedSlo.thirdThemeAnswer === 'yes') {
                        availableLearningOutcomes[program.programId].push(slo)
                    }
                }
            })
        }
    })

    // defaultTabs is provided to Accordion to expand all accordion items by default.
    //let defaultTabs = Array.from(props.department.submittedPrograms, (p,k) => 'program-' + k)
    let defaultTabs = []
    props.department.submittedPrograms.forEach((p) => {
        if (!(p.programId in props.step4CompletionData && props.step4CompletionData[p.programId].completed)) {
            defaultTabs.push(prefix + p.programId)
        }
    })
    
    return (
        <React.Fragment>
            <StepHeader text={props.stepTitle} />

            <div className="p-5 pb-md-4 mx-auto">
                <div className="p-1 text-center">
                    Use the ‘Edit’ buttons below to describe the analysis performed on 
                    the data collected for each current learning outcome (and gen ed 
                    essential skill). Please review background information about Analyzing 
                    Assessment Data before continuing: <a href="https://rise.articulate.com/share/FnW6jBaKdsAvn-k5GnSigw6uRGayAGsl#/lessons/qXYFHa9avJdKIltNqDeG_NDKVJ5vElf2" target="_blank" rel="noopener noreferrer">View</a>
                </div>
                <div className="p-1 text-center">
                    If you have any data attachments or additional information or documents to 
                    share or save please save your documents in <a href="https://livecnm.sharepoint.com/:f:/t/SAAC/ElP7hfcN6OVMhcTxMFhKQSUB-TcaxizLB3gZuRrXPXf0iA?e=nlvD7d" target="_blank" rel="noopener noreferrer">this SAAC folder</a>.
                    Suggested naming convention: <span className="fst-italic">PROGRAM PREFIX_DocType_year</span>
                    <p className="p-2">
                    For example, <span className="fw-bold">THEA_data_2023</span> or <span className="fw-bold">FILM_rubric_2023</span>
                    </p>
                </div>
                <DepartmentHeader department={props.department} />

                <div className="pb-md-4 mx-auto">
                    <Accordion defaultActiveKey={defaultTabs} alwaysOpen>
                    {
                        filteredPrograms?.map((program,key) =>
                        <Accordion.Item eventKey={prefix + program.programId} key={program.programId}>
                            <Accordion.Header>
                                {program.name} {(program.programId in props.step4CompletionData && props.step4CompletionData[program.programId].completed) ? ' - Completed' : ''}
                            </Accordion.Header>
                            <Accordion.Body>
                                <Table key={key}>
                                    <thead>
                                        <tr>
                                            <th>Learning Outcome</th>
                                            <th></th>
                                            <th>Data Analysis 1</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            availableLearningOutcomes[program.programId].map((slo,index) => {
                                                return (
                                                <tr key={index}>
                                                    <td style={{width: "80%"}}>
                                                        { slo.text }
                                                    </td>
                                                    <td>
                                                    </td>
                                                    <td style={{width: "15%"}}>
                                                        <EditButton
                                                            onClick={handleOpenEditDialog}
                                                            programId={program.programId}
                                                            sloId={slo.sloId}
                                                            disabled={isStep2DataAvailable(program.programId, slo.sloId)}
                                                            completed={isLearningOutcomeDataComplete(program.programId, slo.sloId)}
                                                            />
                                                    </td>
                                                </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </Table>
                                <Container fluid>
                                    <Row>
                                        <Col 
                                            md={{span: 8, offset: 3}}
                                            lg={{span: 12, offset: 3}}
                                            >
                                            <CompletedCheckBox
                                                onChange={props.onStepCompleted}
                                                programId={program.programId}
                                                completed={props.step4CompletionData[program.programId]?.completed}
                                                defaultChecked={props.step4CompletionData[program.programId]?.completed}
                                                ariaLabel="Step 4 is complete"
                                                label="By checking this box you are completing Step 4 for your program area"
                                                step="4"
                                                disabled={!isStepComplete(program.programId)}
                                                />
                                        </Col>
                                    </Row>
                                </Container>
                            </Accordion.Body>
                        </Accordion.Item>
                        )
                    }
                    </Accordion>
                </div>
            </div>
            <DataAnalysisDialog
                department={props.department}
                theme={props.theme}
                selectedProgram={selectedProgram}
                selectedLearningOutcome={selectedLearningOutcome}
                learningOutcomes={availableLearningOutcomes}
                sloQuestions={props.sloQuestions}
                step1DataStore={props.step1DataStore}
                sloAnalysis={props.sloAnalysis[selectedProgram?.programId]}
                stepData={stepData}
                step2DataStore={props.step2DataStore}
                stepCompletionData={props.step4CompletionData}
                step1CompletionData={props.step1CompletionData}
                step2CompletionData={props.step2CompletionData}
                step3CompletionData={props.step3CompletionData}
                showModal={showModal}
                handleCloseDialog={handleCloseDialog}
                handleCancelDialog={handleCancelDialog}
                handleLearningOutcomeChanged={handleLearningOutcomeChanged}
                onSummaryOfResultsChanged={(e) => setStepData(prevStepData => ({...prevStepData, summaryOfResults: e.target.value}) )}
                onReflectionOnHypothesisChanged={(e) => setStepData(prevStepData => ({...prevStepData, reflectionOnHypothesis: e.target.value}) )}
                onInterpretationOfResultsChanged={(e) => setStepData(prevStepData => ({...prevStepData, interpretationOfResults: e.target.value}) )}
                onFollowUpQuestionsChanged={(e) => setStepData(prevStepData => ({...prevStepData, followUpQuestions: e.target.value}) )}
                onActionsForImprovementChanged={(e) => setStepData(prevStepData => ({...prevStepData, actionsForImprovement: e.target.value}) )}
                />
        </React.Fragment>
    )
}